import { ApiEndpoints } from "api/endpoints";
import { makeMutation } from "api/api";
import * as z from "zod";
import { ResultSchema } from "model/result/schema";
import { generalErrorCodes } from "shared/errors/generalErrorCodes";

const ResultCreateSchema = z.object({
  success: z.literal(true),
  data: z.object({
    id: z.number(),
  }),
});

export const MutateResultCreateParamsSchema = ResultSchema.omit({id: true, userId: true, avgScore: true});

export type MutateResultCreateParams = z.infer<typeof MutateResultCreateParamsSchema>;

export const mutateResultCreate = async (values: MutateResultCreateParams) => {
  const response = await makeMutation(ApiEndpoints.resultList(), values, true, 'POST', generalErrorCodes);
  return ResultCreateSchema.parse(response);
};
